<template>
  <div class="statistic">
    <a-layout>
      <a-layout-content
        style="background-color: '#2F3D4F; margin: 20px; position: relative"
      >
        <div class="header">
          <div class="img">
            <img :src="url" alt="">
          </div>
          <div class="input">
            <el-date-picker
              type="daterange"
              align="right"
              unlink-panels
              v-model="outerDateValue"
              :key="lang"
            />
            <button
              v-if="buttonsShow['device:manage:device:history:query']"
              @click="render"
            >
              {{ $t('buttons.search') }}
            </button>
            <button @click="exportExcel">
              {{ $t('buttons.export') }}
            </button>
            <button @click="initialAvgConsumptionChart">
              {{ $t('buttons.comparisonOfGasElectricityRatio') }}
            </button>
            <button @click="initialDeviceTChart">
              {{ $t('buttons.time') }}
            </button>
            <button
              v-if="buttonsShow['device:manage:device:history:delete']"
              @click="showRemoveHistroyDataConfirm"
            >
              {{ $t('buttons.history') }}
            </button>
            <!-- 数据连续显示 -->
            <!-- <label>{{ $t('device.Continuous') }}</label>
            <a-switch
              style="margin-top: -3px"
              v-model="completeState"
              :checked-children="$t('common.yes')"
              :un-checked-children="$t('common.no')"
              @change="handleDataShowModalChange"
            /> -->
          </div>
          <div class="exportData">
            <label>{{ $t('device.exportP') }}</label>
            <a-switch
              style="margin-top: -3px"
              v-model="exportType"
              :checked-children="$t('common.yes')"
              :un-checked-children="$t('common.no')"
            />
            <label>{{ $t('device.exportI') }}</label>
            <a-select
              dropdownClassName="selectOption"
              :style="`width: ${ lang === 'en' ? '110' : '80' }px; margin-right: 10px`"
              v-model="unit"
              @change="handleUnitChange"
            >
              <a-select-option value="s">
                {{ $t('common.second') }}
              </a-select-option>
              <a-select-option value="m">
                {{ $t('common.minute') }}
              </a-select-option>
              <a-select-option value="h">
                {{ $t('common.hour') }}
              </a-select-option>
            </a-select>
            <a-select
              dropdownClassName="selectOption"
              style="width: 80px"
              v-model="num"
            >
              <a-select-option v-for="o in options" :key="o" :value="o">
                {{ o }}
              </a-select-option>
            </a-select>
            <a-button
              type="primary"
              @click="showRateMask"
            >
              {{ $t('device.count') }}
            </a-button>
            <a-button
              type="primary"
              v-show="rateInterval && buttonsShow['device:manage:samplingRate:query']"
              @click="setRate(false)"
            >
              {{ defaultRate }}
            </a-button>
            <a-button
              type="primary"
              v-show="$route.query.type === 'DB'"
              @click="setLoadRateInfoAndShowLoadRateModal"
              :loading="loadRateModalButtonLoading"
            >
              {{ $t('device.loadRateCalculation') }}
            </a-button>
          </div>
          <h2 style="position: absolute; right: 50px; top: 0; color: #fff">{{ $route.query.name }}</h2>
          <ul class="pointsList" v-if="isContentShow">
            <li
              v-for="(item, index) in points"
              :key="index"
            >
              <label :for="item.code">
                <input
                  type="checkbox"
                  style="margin-right: 10px"
                  :id="item.code"
                  :checked="item.checked"
                  @change="handlePointCheckedChange($event, item)"
                />
                {{ item[lang] }} ({{ item.unit }})
              </label>
            </li>
          </ul>
        </div>
        <a-spin size="large" style="position:absolute; left: 50%; transform: translateX(-50%)" v-show="!isChartsShow" />
        <div class="container" v-show="isChartsShow">
          <ul class="charts">
            <li>
              <h3>
                {{ $t('device.summary') }}
                <a-button style="position: absolute; background-color: rgb(47, 61, 79); color: #fff; border-bottom: none; z-index: 10; right: 20px;" @click="isParameterSettingVisible = true">
                  {{ $t('device.axis') }}
                </a-button>
              </h3>
              <hr />
              <div id="summary"></div>
            </li>
            <li
              v-for="(item, index) in points"
              :key="item.code"
              v-show="item.checked"
            >
              <h3>
                {{ item[lang] }}
                <a-button style="float: right; background-color: rgb(47, 61, 79); color: #fff; border-bottom: none; z-index: 1" @click="openRangeMask(item, index)">
                  {{ $t('device.distribution') }}
                </a-button>
              </h3>
              <hr />
              <div :id="item.name"></div>
            </li>
          </ul>
        </div>
      </a-layout-content>
    </a-layout>
    <div class="mask statistics avgConsumption" v-show="avgConsumptionVisible">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeAvgConsumptionMask" />
          <div class="box">
            <a-button type="primary" style="margin-bottom: 10px" @click="addRange">{{ $t('device.addRange') }}</a-button>
            <a-button type="primary" style="margin: 0 10px 10px" @click="renderChart" v-show="removeBtnShow">{{ $t('device.analysis') }}</a-button>
            <a-button type="primary" style="margin-bottom: 10px;" @click="removeRange" v-show="removeBtnShow">{{ $t('device.removeRange') }}</a-button>
            <ul>
              <li v-for="(range, index) in ranges" :key="range.id">
                <a-checkbox v-model="range.checked" :id="range.id" />
                <label :for="range.id">{{ $t('device.range') }}{{ index + 1 }}：</label>
                <el-date-picker
                  style="width: 140px; margin-left: 25px; display: flex; align-items: center; margin-top: -10px;"
                  type="date"
                  :placeholder="$t('device.selectDate')"
                  v-model="range.date"
                />
                <div class="time_wrapper">
                  <el-time-select
                    style="margin-left: 10px"
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    :placeholder="$t('device.selectTime')"
                    v-model="range.startTime"
                  />
                  <span style="color: #fff; margin: 0 8px">-</span>
                  <el-time-select
                    :picker-options="{
                      start: '01:00',
                      step: '01:00',
                      end: '24:00'
                    }"
                    :placeholder="$t('device.selectTime')"
                    v-model="range.endTime"
                  />
                </div>
              </li>
            </ul>
          </div>
          <div class="chart"></div>
        </div>
      </div>
    </div>
    <div class="mask time" v-show="timeShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeTime" />
          <div class="head">
            <h2 style="color: #fff">
              {{$route.query.name}}
              <a-select v-model="timeDevice" style="width: 200px; margin-left: 15px">
                <a-select-option v-for="data in points" :key="data.code" :value="data.code">
                  {{ data[lang] }}
                </a-select-option>
              </a-select>
              <a-button type="primary" @click="addTimeRange" style="margin-left: 15px">{{ $t('device.addRange') }}</a-button>
              <a-button v-show="timeRanges.length" type="primary" style="margin: 0 15px" @click="timeAnalyse" :loading="tLoading">{{ $t('device.analysis') }}</a-button>
              <a-button v-show="timeRanges.length" type="primary" @click="timeGoBack">{{ $t('device.countermand') }}</a-button>
            </h2>
          </div>
          <div class="box">
            <ul style="overflow: hidden">
              <li v-for="(range, i) in timeRanges" :key="range.id">
                <label style="display: inline-block; width: 66px">{{ $t('device.range') }}{{i + 1}}：</label>
                <el-date-picker
                  v-model="range.dateRange"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :picker-options="pickerOptions"
                  style="background-color: #2f3d4f;"
                  @change="changeTime($event, i)"
                />
              </li>
            </ul>
            <div class="content">
              <div class="chart" id="time"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-model="isRemoveHistroyDataConfirm" :title="$t('device.confirm')" @ok="removeHistroyData" :okText="$t('common.okText')" :cancelText="$t('common.cancelText')">
      <a-form-model class="removeModal">
        <a-form-model-item :label="$t('device.selectRange')">
          <a-range-picker
            v-model="removeTimeRange"
            style="width: 100%;"
            :show-time="{ format: 'HH:mm:ss' }"
            format="YYYY-MM-DD HH:mm:ss"
            :placeholder="[$t('common.startTime'), $t('common.endTime')]"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <div class="mask rate" v-show="rateShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeRate" />
          <div class="head">
            <h2 style="color: #fff">
              {{$route.query.name}}
              <br />
              <label>{{ $t('history.dateRange') }}</label>
              <el-date-picker
                v-model="rateDateRange"
                type="datetimerange"
                align="right"
                unlink-panels
                :picker-options="pickerOptions"
                style="background-color: #2f3d4f; margin: 20px 15px 20px 0"
              />
              <a-button type="primary" @click="saveTime">{{ $t('buttons.save') }}</a-button>
              <br />
              <label style="margin-bottom: 20px">{{ $t('device.acquisitionInterval') }}</label>
              <a-select dropdownClassName="selectOption" style="width: 100px; margin-bottom: 20px" v-model="rateInterval">
                <a-select-option value="10">10</a-select-option>
                <a-select-option value="20">20</a-select-option>
                <a-select-option value="30">30</a-select-option>
                <a-select-option value="60">60</a-select-option>
                <a-select-option value="180">180</a-select-option>
                <a-select-option value="300">300</a-select-option>
                <a-select-option value="600">600</a-select-option>
              </a-select>
              <span style="margin-left: 10px; font-size: 16px">{{ $t('common.second') }}</span>
              <br />
              <a-button :loading="isRateLoading" type="primary" style="margin-bottom: 20px" @click="setRate">{{ $t('history.calculate') }}</a-button>
              <br />
              {{ $t('device.expection') }}{{ rateTarget }}
              <br />
              {{ $t('device.real') }}{{ rateResult }}
              <br />
              {{ $t('device.rate') }}{{ rate }}
            </h2>
          </div>
        </div>
      </div>
    </div>
    <div ref="range" class="mask range" v-show="rangeShow">
      <div class="wrapper" @mousedown="handleMouseDown">
        <div class="container" style="padding-bottom: 20px">
          <a-icon :type="shrink ? 'arrows-alt' : 'shrink'" style="right: 50px" @click="setShrink" />
          <a-icon type="close" @click="closeRangeMask"  @mousedown.stop="" />
          <div class="head" @mousedown.stop="">
            <h2 style="color: #fff">
              {{ $route.query.name }} - {{ dataPointName }}
              <el-date-picker
                v-model="rangeDateValue"
                type="daterange"
                align="right"
                unlink-panels
                :picker-options="pickerOptions"
                style="background-color: #2f3d4f; margin: 0 20px"
                @change="onRangeDateChange"
              />
              <a-button type="primary" @click="addDataRange">{{ $t('device.addRange') }}</a-button>
              <a-button type="primary" style="margin: 0 15px" @click="analyse" v-show="dataRanges.length > 0" :loading="isLoading">{{ $t('device.analysis') }}</a-button>
              <a-button type="primary" @click="goBack" v-show="dataRanges.length > 0">{{ $t('device.countermand') }}</a-button>
            </h2>
          </div>
          <div class="box" @mousedown.stop="">
            <ul style="overflow: hidden; margin: 20px 0">
              <li v-for="(item, i) in dataRanges" :key="item.id" class="formList">
                <a-input style="color: #fff; width: 25%; background: #2f3d4f;" v-model="item.min" />
                <span style="color: #fff">≤</span>
                <div>
                  <label style="display: inline-block; margin-right: 10px">{{ $t('device.range') }}{{ i + 1 }}：</label>
                </div>
                <span style="color: #fff">＜</span>
                <a-input style="color: #fff; width: 25%; background: #2f3d4f;" v-model="item.max" />
              </li>
            </ul>
            <div class="content">
              <div class="detail">
                <h3>{{ $t('device.distributionD') }}</h3>
                <ul>
                  <li v-for="(value, key) in dataRangeDetail" :key="key"><span>{{ key }}: </span><span style="font-size: 18px">{{value}}</span></li>
                </ul>
                <a-button type="primary" @click="renderRangesChart">{{ $t('device.chart') }}</a-button>
              </div>
              <div class="chart" id="ranges"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask loadRate" v-show="loadRateShow">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeLoadRateModalAndClearInfo" />
          <div class="head">
            <h2 style="color: #fff">
              {{$route.query.name}}
              <br />
            </h2>
            <a-menu v-model="loadRateType" mode="horizontal" style="background-color: #2f3d4f; margin-bottom: 15px; color: #fff; font-size: 16px">
              <a-menu-item key="IndustrialFrequency" style="margin-right: 15px" @click="setLoadRateForm">{{ $t('device.IndustrialFrequency') }}</a-menu-item>
              <a-menu-item key="variableFrequency" @click="setLoadRateForm">{{ $t('device.variableFrequency') }}</a-menu-item>
            </a-menu>
          </div>
          <div class="box">
            <div class="left">
              <div class="form">
                <a-form-model ref="loadRateForm" layout="inline" style="margin-top: 15px;" :model="loadRateForm" :rules="loadRateRules">
                  <a-form-model-item required :label="$t('device.dateRange')" style="margin-bottom: 8px; margin-left: -7px" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                    <el-date-picker
                      type="datetimerange"
                      align="right"
                      unlink-panels
                      v-model="loadRateDateRange"
                      :key="lang"
                      @change="validateDate"
                    />
                  </a-form-model-item>
                  <br />
                  <div class="flex">
                    <a-form-model-item style="margin-right: 60px; position: relative" v-if="loadRateType[0] === 'IndustrialFrequency'" :label="$t('device.unloadingPower') + '(kW)'" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }" prop="unloadingPower">
                      <a-input v-model="loadRateForm.unloadingPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('unloadingPower', 'enterUnloadingPower')" :loading="isunloadingPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                    <a-form-model-item style="position: relative; margin-right: 60px" :label="$t('device.fullLoadPower') + '(kW)'" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }" prop="fullLoadPower" v-if="loadRateType[0] === 'variableFrequency'">
                      <a-input v-model="loadRateForm.fullLoadPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('fullLoadPower', 'enterFullLoadPower')" :loading="isfullLoadPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                    <a-form-model-item :label="$t('device.stanbyPower') + '(kW)'" :label-col="{ span: 11 }" :wrapper-col="{ span: 13 }" prop="stanbyPower">
                      <a-input v-model="loadRateForm.stanbyPower" style="background-color: #2f3d4f; color: #fff; width: 70%" />
                      <a-button type="primary" style="position: absolute; left: 110%; top: 50%; transform: translateY(-50%)" @click="saveLoadRateSettings('stanbyPower', 'enterStanbyPower')" :loading="isstanbyPowerSaving">{{ $t('buttons.save') }}</a-button>
                    </a-form-model-item>
                  </div>
                </a-form-model>
                <!-- <label style="margin-left: 0;">
                  {{ $t('station.ds') }}: 
                </label> -->
                <header style="margin-top: 5px;">
                  <label style="margin-left: 0;">{{ $t('station.ds') }}: </label>
                  <!-- <a-button type="primary" style="margin-left: 10px;" @click="saveDevices" :loading="isDeviceSaving">{{ $t('buttons.save') }}</a-button> -->
                </header>
                <div class="paramGroups">
                  <!-- <div class="paramGroup" v-for="d in deviceList" :key="d.id">
                    <a-checkbox/>
                    <label>{{ d.name }}</label>
                  </div> -->
                  <a-radio-group style="width: 100%;" v-model="selectedDevices" v-if="loadRateType[0] === 'variableFrequency'">
                    <a-row>
                      <a-col :span="8" v-for="d in deviceList" :key="d.id">
                        <a-radio :value="d.id">
                          {{ d.name }}
                        </a-radio>
                      </a-col>
                    </a-row>
                  </a-radio-group>
                  <a-radio-group v-else style="width: 100%;" v-model="selectedDevice">
                    <a-row>
                      <a-col :span="8" v-for="d in deviceList" :key="d.id">
                        <a-radio  :value="d.id">
                          {{ d.name }}
                        </a-radio>
                      </a-col>
                    </a-row>
                  </a-radio-group>
                </div>
              </div>
              <div class="result">
                <header style="margin-top: 5px;">
                  <label style="margin-left: 0;">{{ $t('device.result') }}: </label>
                  <a-button type="primary" style="margin-left: 10px;" @click="getLoadRate" :loading="isGettingLoadRateButtonLoading">{{ $t('history.calculate') }}</a-button>
                </header>
                <div class="content">
                  <template v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <div>
                      <label>{{ $t('device.dataCount') }}: </label>
                      <span class="data">{{ dataCount }}</span>
                    </div>
                    <div>
                      <label>{{ $t('device.loadCount') }}: </label>
                      <span class="data">{{ loadCount }}</span>
                    </div>
                    <div>
                      <label>{{ $t('device.unloadCount') }}: </label>
                      <span class="data">{{ unloadCount }}</span>
                    </div>
                  </template>
                  <div v-if="loadRateType[0] === 'variableFrequency'">
                    <label>{{ $t('station.aPower') }}: </label>
                    <span class="data">{{ avgPower }} kW</span>
                  </div>
                  <div>
                    <label>{{ $t('device.electricityMeterAccumulation') }}: </label>
                    <span class="data">{{ electricityMeterAccumulation }} kW·H</span>
                  </div>
                  <template v-if="loadRateType[0] === 'variableFrequency'">
                    <div>
                      <label>{{ $t('device.maxPower') }}: </label>
                      <span class="data">{{ maxPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.minPower') }}: </label>
                      <span class="data">{{ minPower }} kW</span>
                    </div>
                  </template>
                  <div v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <label>{{ $t('device.loadingRate') }}: </label>
                    <span class="data">{{ loadingRate }} %</span>
                  </div>
                  <div v-if="loadRateType[0] === 'variableFrequency'">
                    <label>{{ $t('device.capacityRate') }}: </label>
                    <span class="data">{{ capacityRate }} %</span>
                  </div>
                  <template v-if="loadRateType[0] === 'IndustrialFrequency'">
                    <div>
                      <label>{{ $t('device.unloadRate') }}: </label>
                      <span class="data">{{ unloadRate }} %</span>
                    </div>
                    <div>
                      <label>{{ $t('station.aPower') }}: </label>
                      <span class="data">{{ avgPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.maxPower') }}: </label>
                      <span class="data">{{ maxPower }} kW</span>
                    </div>
                    <div>
                      <label>{{ $t('device.minPower') }}: </label>
                      <span class="data">{{ minPower }} kW</span>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="right">
              <header>
                <label style="margin-left: 0; font-size: 18px">{{ $t('dataReport.calculation') }}: </label>
              </header>
              <div style="display: flex; flex-direction: column; justify-content: space-between; height: 94.5%">
                <section>
                  <label>{{ $t('device.dateRange') }}: </label>
                  <span>{{ $t('device.description.dateRange') }}</span>
                  <br>
                  <label>{{ $t('device.unloadingPower') }}: </label>
                  <span>{{ $t('device.description.unloadingPower') }}</span>
                  <br>
                  <label>{{ $t('device.fullLoadPower') }}: </label>
                  <span>{{ $t('device.description.fullLoadPower') }}</span>
                  <br>
                  <label>{{ $t('device.stanbyPower') }}: </label>
                  <span>{{ $t('device.description.stanbyPower') }}</span>
                  <br>
                </section>
                <section style="margin-top: 20px;">
                  <label>{{ $t('station.aPower') }}=</label>
                  <span>{{ $t('device.description.aPower') }}</span>
                  <br>
                  <label>{{ $t('device.electricityMeterAccumulation') }}=</label>
                  <span>{{ $t('device.description.electricityMeterAccumulation') }}</span>
                  <br>
                  <label>{{ $t('device.maxPower') }}=</label>
                  <span>{{ $t('device.description.maxPower') }}</span>
                  <br>
                  <label>{{ $t('device.minPower') }}=</label>
                  <span>{{ $t('device.description.minPower') }}</span>
                  <br>
                  <label>{{ $t('device.loadingRate') }}=</label>
                  <span>{{ $t('device.description.loadingRate') }}</span>
                  <br>
                  <label>{{ $t('device.capacityRate') }}=</label>
                  <span>{{ $t('device.description.capacityRate') }}</span>
                  <br>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mask axis" v-show="isParameterSettingVisible">
      <div class="wrapper">
        <div class="container">
          <a-icon type="close" @click="closeParameterSetting" />
          <div class="content">
            <header>
              <a-button type="primary" @click="addParameter">{{ $t("buttons.addParam") }}</a-button>
            </header>
            <ul class="parameters" style="margin-top: 12px;">
              <li
                v-for="(p, i) in parametersAxisSettings"
                :key="p.id"
              >
                <label style="margin-left: 0;">{{ $t("configuration.parameter") }}{{ i + 1 }}: </label>
                <a-select v-model="p.selectedPoints" mode="multiple" dropdownClassName="selectOption" style="width: 400px; margin: 0 10px;" :placeholder="$t('device.selectPoints')">
                  <a-select-option
                    v-for="p in points"
                    :key="p.code"
                  >
                    {{ p[lang] }}
                  </a-select-option>
                </a-select>
                <a-input v-model="p.min" style="width: 166px; margin-right: 10px;" :placeholder="$t('device.enterMinAxis')"></a-input>
                <a-input v-model="p.max" style="width: 166px;" :placeholder="$t('device.enterMaxAxis')"></a-input>
                <i @click="deleteParameterSetting(i)">
                  <svg t="1765332838466" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1818" width="24" height="30"><path d="M607.897867 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L575.903242 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 351.94087C639.892491 753.593818 625.61532 768.043004 607.897867 768.043004z" fill="#ccc" p-id="1819"></path><path d="M415.930119 768.043004c-17.717453 0-31.994625-14.277171-31.994625-31.994625L383.935495 383.935495c0-17.717453 14.277171-31.994625 31.994625-31.994625 17.717453 0 31.994625 14.277171 31.994625 31.994625l0 351.94087C447.924744 753.593818 433.647573 768.043004 415.930119 768.043004z" fill="#ccc" p-id="1820"></path><path d="M928.016126 223.962372l-159.973123 0L768.043004 159.973123c0-52.980346-42.659499-95.983874-95.295817-95.983874L351.94087 63.989249c-52.980346 0-95.983874 43.003528-95.983874 95.983874l0 63.989249-159.973123 0c-17.717453 0-31.994625 14.277171-31.994625 31.994625s14.277171 31.994625 31.994625 31.994625l832.032253 0c17.717453 0 31.994625-14.277171 31.994625-31.994625S945.73358 223.962372 928.016126 223.962372zM319.946246 159.973123c0-17.545439 14.449185-31.994625 31.994625-31.994625l320.806316 0c17.545439 0 31.306568 14.105157 31.306568 31.994625l0 63.989249L319.946246 223.962372 319.946246 159.973123 319.946246 159.973123z" fill="#ccc" p-id="1821"></path><path d="M736.048379 960.010751 288.123635 960.010751c-52.980346 0-95.983874-43.003528-95.983874-95.983874L192.139761 383.591466c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 480.435411c0 17.717453 14.449185 31.994625 31.994625 31.994625l448.096758 0c17.717453 0 31.994625-14.277171 31.994625-31.994625L768.215018 384.795565c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 479.231312C832.032253 916.835209 789.028725 960.010751 736.048379 960.010751z" fill="#ccc" p-id="1822"></path></svg>
                </i>
              </li>
            </ul>
          </div>
        </div>
        <footer>
          <div class="buttons">
            <a-button @click="closeParameterSetting">{{ $t("common.cancelText") }}</a-button>
            <a-button type="primary" style="margin-left: 12px;" @click="confirmAxisSetting">{{ $t("common.okText") }}</a-button>
          </div>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import url from '@/assets/product.png'
import formatDate from '@/components/function/formatDate'
import moment from 'moment'
// import completeData from '@/components/function/completeData'
import * as XLSX from '@/plugins/export-excel'
import { getProtocol } from '@/api/protocol'
import {
  getDeviceHistoryData,
  getDayReport,
  deleteDeviceHistoryData,
  searchDeviceList
} from '@/api/device'
import { nanoid } from 'nanoid'
import { f, u } from '@/api/order'

export default {
  data() {
    return {
      url,
      outerDateValue: null,
      buttonsShow: {},
      exportType: true,
      unit: 'm',
      num: 1,
      perSeconds: 60,
      options: [1, 5, 30],
      isContentShow: false,
      isChartsShow: false,
      points: [],
      avgConsumptionVisible: false,
      ranges: [],
      timeShow: false,
      tLoading: false,
      timeDevice: '',
      timeRanges: [],
      pickerOptions: {
        shortcuts: [
          {
            text: this.$t('station.tld'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlw'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: this.$t('station.tlm'),
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      isRemoveHistroyDataConfirm: false,
      removeTimeRange: [],
      rateShow: false,
      rateDateRange: [],
      rateInterval: '',
      isRateLoading: false,
      rate: '',
      rateTarget: '',
      rateResult: '',
      defaultRate: '',
      rangeShow: false,
      dataPointName: '',
      rangeDateValue: '',
      dataRanges: [],
      isLoading: false,
      dataRangeDetail: {},
      shrink: false,
      completeState: false,
      loadRateShow: false,
      deviceList: [],
      loadRateDateRange: [],
      loadRateModalButtonLoading: false,
      loadRateForm: {
        unloadingPower: '',
        fullLoadPower: '',
        stanbyPower: '1'
      },
      loadRateRules: {},
      parameters: [],
      avgPower: 0,
      electricityMeterAccumulation: 0,
      maxPower: 0,
      minPower: 0,
      loadingRate: 0,
      capacityRate: 0,
      pointsOfLoadRate: [],
      isGettingLoadRateButtonLoading: false,
      selectedDevices: undefined,
      selectedDevice: undefined,
      loadRateType: ['IndustrialFrequency'],
      dataCount: 0,
      loadCount: 0,
      unloadCount: 0,
      unloadRate: 0,
      isunloadingPowerSaving: false,
      isfullLoadPowerSaving: false,
      isstanbyPowerSaving: false,
      isDeviceSaving: false,
      parametersAxisSettings: [],
      isParameterSettingVisible: false
    }
  },
  computed: {
    removeBtnShow() {
      return this.ranges.some(item => item.checked)
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    rateInterval() {
      this.setRate(false)
    },
    lang() {
      this.translate()
      this.$nextTick(() => {
        this.drawSummaryChart()
        this.drawPointsCharts()
      })
    }
  },
  created() {
    this.memo = []
    this.translate()
    const now = new Date(new Date().toDateString())
    this.outerDateValue = [now, now]
    const authorities = this.getAuthorities('/equipment/list')
    for (let i = 0; i < authorities.length; i++) {
      this.buttonsShow[authorities[i].code] = true
    }
    this.deviceCode = this.$route.query.code
    const LKEY = `${this.deviceCode}`
    const LVALUE = localStorage.getItem(LKEY)
    if (LVALUE) {
      this.selectedPoints = JSON.parse(LVALUE)
    } else {
      this.selectedPoints = []
    }
    this.axisMap = {}
  },
  async mounted() {
    await this.getPoints()
    const r = JSON.parse(localStorage.getItem('statisticsTime'))
    if (r) {
      const t = localStorage.getItem('saveTime')
      if (t === moment(+new Date()).format('YYYY-MM-DD')) {
        this.rateDateRange = r.map(d => new Date(d))
      } else {
        localStorage.removeItem('saveTime')
        localStorage.removeItem('statisticsTime')
        this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
      }
    } else {
      this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
    }
    if (this.$route.query.rateInterval) {
      this.rateInterval = this.$route.query.rateInterval
    }
    await this.render()
    this.setRate(false)
    this.getMemo()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.summaryChart.resize)
    this.summaryChart.dispose()
    for (let i = 0; i < this.points.length; i++) {
      window.removeEventListener('resize', this[`charts${i}`].resize)
      this[`charts${i}`].dispose()
      this[`charts${i}`] = null
    }
    if (this.webSocket) {
      this.webSocket.close()
      this.webSocket = null
    }
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  },
  methods: {
    translate() {
      this.loadRateRules = {
        unloadingPower: [
          {
            required: true,
            message: this.$t('device.enterUnloadingPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ],
        fullLoadPower: [
          {
            required: true,
            message: this.$t('device.enterFullLoadPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ],
        stanbyPower: [
          {
            required: true,
            message: this.$t('device.enterStanbyPower'),
            trigger: 'blur'
          },
          {
            validator: this.validateNumber,
            trigger: 'blur'
          }
        ]
      }
    },
    validateNumber(_, value, callback) {
      if (isNaN(+value)) {
        callback(new Error(this.$t('device.enterNumber')))
      } else {
        callback()
      }
    },
    async getMemo() {
      try {
        const { data } = await f()
        this.memo = data
      } catch(e) {
        console.log(e)
      }
    },
    setLoadRateForm({ key }) {
      if (this.memo[1][this.$route.query.id]) {
        for (let k in this.memo[1][this.$route.query.id][key]) {
          this.loadRateForm[k] = this.memo[1][this.$route.query.id][key][k]
        }
        this.loadRateForm.stanbyPower = this.loadRateForm.stanbyPower || '1'
        if (key === 'IndustrialFrequency') {
          this.selectedDevice = this.memo[1][this.$route.query.id].IndustrialFrequency.device || +this.$route.query.id
        }
        if (key === 'variableFrequency') {
          this.selectedDevices = this.memo[1][this.$route.query.id].variableFrequency.devices || +this.$route.query.id
        }
      } else {
        this.selectedDevice = +this.$route.query.id
        this.selectedDevices = +this.$route.query.id
      }
      this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = this.dataCount = this.loadCount = this.unloadCount = 0
    },
    async saveLoadRateSettings(field, messageField) {
      this.loadRateForm[field] = this.loadRateForm[field].trim()
      if (!this.loadRateForm[field]) {
        return this.$message.warn(this.$t(`device.${messageField}`))
      }
      this[`is${field}Saving`] = true
      let loadRateInfo = this.memo[1][this.$route.query.id]
      if (!loadRateInfo) {
        this.memo[1][this.$route.query.id] = {
          IndustrialFrequency: {},
          variableFrequency: {}
        }
      }
      this.memo[1][this.$route.query.id][this.loadRateType[0]][field] = this.loadRateForm[field]
      try {
        const { message } = await u(this.memo)
        this.$message.success(message)
      } catch(e) {
        console.log(e)
      } finally {
        this[`is${field}Saving`] = false
      }
    },
    async getPoints() {
      try {
        const { data } = await getProtocol(this.$route.query.pc)
        data.points.filter(d => d.dataWrite !== 2).forEach(p => {
          p.zh = p.name
          p.en = p.details?.find(d => d.locale === 'en-US')?.name
          if (!p.en) {
            p.en = p.zh
          }
          if (p.read !== false && p.dataWrite !== 2) {
            p.checked = !!this.selectedPoints.find(s => s === p.code)
            this.points.push(p)
          }
        })
      } catch(e) {
        console.log(e)
      } finally {
        this.isContentShow = true
      }
    },
    async render() {
      if (this.webSocket) {
        this.webSocket.close()
        this.webSocket = null
      }
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      const reduce = parseInt((this.outerDateValue[1] - this.outerDateValue[0]) / 1000 / 3600 / 24)
      if (reduce > 31) {
        return this.$message.warn(this.lang === 'en' ? 'Date range up to one month' : '日期范围最多一个月')
      }
      this.isChartsShow = false
      this.selectedPoints = this.points.filter(p => p.checked)
      await this.getData()
      // if (!this.completeState) {
        // for (let key in this.historyMap) {
        //   this.historyMap[key] = completeData(this.historyMap[key], this.rateInterval, this.outerDateValue)
        // }
      // }
      this.isChartsShow = true
      // if (+this.outerDateValue[1] + 24 * 3600000 - 1 > +new Date()) {
      //   this.connectWebSocket()
      //   this.checkWebSocketConnecting()
      // }
      this.$nextTick(() => {
        this.drawSummaryChart()
        this.drawPointsCharts()
      })
    },
    async getData(targetField = 'historyMap', dateField = 'outerDateValue', pointsField = 'points') {
      try {
        const params = {
          deviceId: this.$route.query.id,
          pointCode: this[pointsField].map(p => p.code) + '',
          startTime: +this[dateField][0],
          endTime: +this[dateField][1] + 24 * 3600000 - 1
        }
        const { data } = await getDeviceHistoryData(params)
        this[targetField] = {}
        let target, time, plm
        this.pointsDataLengthMap = {}
        this.originHistoryData = data.map(d => {
          d.time = +new Date(d.time)
          return d
        })
        for (let i = 0; i < data.length; i++) {
          time = parseInt(new Date(data[i].time) / 1000) * 1000
          for (let k in data[i]) {
            target = this[targetField]
            plm = this.pointsDataLengthMap
            if (target[k]) {
              target[k].push([time, data[i][k]])
              plm[k] = (plm[k] + '').length > (data[i][k] + '').length ? (plm[k] + '').length : (data[i][k] + '').length
            } else {
              target[k] = [[time, data[i][k]]]
              plm[k] = (plm[k] + '').length
            }
          }
        }
      } catch(e) {
        console.log(e)
      }
    },
    drawSummaryChart() {
      const yAxis = [], series = []
      let point, width = 0, leftOffset = 0, rightOffset = 0, offset, position
      console.log(this.selectedPoints)
      let y, k
      for (let i = 0; i < this.selectedPoints.length; i++) {
        point = this.selectedPoints[i]
        if (i > 1 && this.pointsDataLengthMap[this.selectedPoints[i - 2].code] > 4) {
          width = 50
        } else if (i > 1 && this.pointsDataLengthMap[this.selectedPoints[i - 2].code] > 1) {
          width = 38
        } else if (i > 1) {
          width = 30
        }
        if (i % 2 === 0) {
          position = 'left'
          leftOffset += width
          offset = leftOffset
        } else {
          position = 'right'
          rightOffset += width
          offset = rightOffset
        }
        y = {
          type: 'value',
          axisLine: {
            show: true
          },
          axisLabel: {
            show: true,
            fontSize: 12
          },
          splitLine: {
            show: false
          },
          position,
          offset,
          scale: true
        }
        k = this.axisMap[point.code]
        if (k && (k.min || k.min === 0) && k.max) {
          y.min = k.min
          y.max = k.max
        }
        yAxis.push(y)
        series.push({
          type: 'line',
          name: point[this.lang],
          data: this.historyMap[point.code],
          symbol: 'none',
          yAxisIndex: i,
          lineStyle: {
            width: 2
          }
        })
      }
      let zoomStart, zoomEnd, grid, dataZoom
      const height = this.selectedPoints.length > 9 ? 1000 : 240
      let chartsWidth = 1500
      const dom = document.querySelector('.container .charts li')
      if (dom) {
        chartsWidth = dom.clientWidth ? (dom.clientWidth - 100) : 1500
      }
      if (!this.summaryChart) {
        zoomStart = 80
        zoomEnd = 100
      } else {
        zoomStart = this.$echarts.getInstanceByDom(document.getElementById('summary')).getOption().dataZoom[0]?.start || 80
        zoomEnd = this.$echarts.getInstanceByDom(document.getElementById('summary')).getOption().dataZoom[0]?.end || 100
        this.summaryChart.dispose()
      }
      if (this.selectedPoints.length > 9) {
        grid = {
          containLabel: true,
          top: '7%',
          bottom: '80%'
        }
        dataZoom = [
          {
            type: 'inside',
            start: zoomStart,
            end: zoomEnd,
            bottom: '77%'
          },
          {
            start: zoomStart,
            end: zoomEnd,
            bottom: '77%'
          }
        ]
      } else {
        grid = {
          containLabel: true
        }
        dataZoom = [
          {
            type: 'inside',
            start: zoomStart,
            end: zoomEnd
          },
          {
            start: zoomStart,
            end: zoomEnd
          }
        ]
      }
      this.summaryChart = this.$echarts.init(
        document.getElementById('summary'),
        null,
        {
          renderer: 'canvas',
          useDirtyRect: false,
          width: chartsWidth,
          height
        }
      )
      const option = {
        tooltip: {
          trigger: 'axis',
          position: function (pt) {
            return [pt[0], '1%']
          },
          renderMode: 'richText',
          backgroundColor: 'rgba(0, 0, 0, .1)',
          zIndex: 100,
          textStyle: {
            color: '#fff'
          }
        },
        grid,
        xAxis: {
          type: 'time',
          boundaryGap: false
        },
        yAxis,
        series,
        dataZoom
      }
      const summary = document.getElementById('summary').parentNode
      summary.addEventListener('mouseover', e => {
        const canvas = summary.querySelector('canvas')
        if (canvas) {
          canvas.style.zIndex = 1000
        }
      })
      summary.addEventListener('mousemove', e => {
        if (e.offsetY > 268) {
          const canvas = summary.querySelector('canvas')
          if (canvas) {
            canvas.style.zIndex = 0
          }
        }
      })
      summary.addEventListener('mouseleave', () => {
        const canvas = summary.querySelector('canvas')
        if (canvas) {
          canvas.style.zIndex = 0
        }
      })
      this.summaryChart.setOption(series.length ? option : {}, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
      window.addEventListener('resize', this.summaryChart.resize)
    },
    drawPointsCharts() {
      let option, point
      let zoomStart, zoomEnd
      let width = 1500
      const dom = document.querySelector('.container .charts li')
      if (dom) {
        width = dom.clientWidth ? (dom.clientWidth - 100) : 1500
      }
      for (let i = 0; i < this.points.length; i++) {
        point = this.points[i]
        if (!this[`charts${i}`]) {
          zoomStart = 80
          zoomEnd = 100
          this[`charts${i}`] = this.$echarts.init(
            document.getElementById(point.name),
            null,
            {
              renderer: 'canvas',
              useDirtyRect: false,
              width,
              height: 240
            }
          )
        } else {
          zoomStart = this.$echarts.getInstanceByDom(document.getElementById(point.name)).getOption().dataZoom[0].start
          zoomEnd = this.$echarts.getInstanceByDom(document.getElementById(point.name)).getOption().dataZoom[0].end
        }
        option = {
          tooltip: {
            trigger: 'axis',
            position: function (pt) {
              return [pt[0], '10%']
            },
            renderMode: 'richText',
            backgroundColor: 'rgba(0, 0, 0, .1)',
            textStyle: {
              color: '#fff'
            }
          },
          xAxis: {
            type: 'time',
            boundaryGap: false
          },
          yAxis: {
            type: 'value',
            boundaryGap: [0, '100%']
          },
          dataZoom: [
            {
              type: 'inside',
              start: zoomStart,
              end: zoomEnd
            },
            {
              start: zoomStart,
              end: zoomEnd
            }
          ],
          series: [
            {
              name: point[this.lang],
              type: 'line',
              smooth: true,
              symbol: 'none',
              areaStyle: {},
              data: this.historyMap[point.code],
              markPoint: {
                data: [
                  {
                    type: 'max',
                    name: '最大值'
                  },
                  {
                    type: 'min',
                    name: '最小值'
                  }
                ]
              }
            }
          ]
        }
        this[`charts${i}`].setOption(option, { replaceMerge: ['xAxis', 'yAxis', 'series'] })
        window.addEventListener('resize', this[`charts${i}`].resize)
      }
    },
    exportExcel() {
      const reduce = parseInt((this.outerDateValue[1] - this.outerDateValue[0]) / 1000 / 3600 / 24)
      if (reduce > 31) {
        return this.$message.warn(this.lang === 'en' ? 'Date range up to one month' : '日期范围最多一个月')
      }
      const dataUnitsGap = this.perSeconds * this.num * 1000
      const headerList = [this.$t('common.deviceCode'), this.$t('common.deviceName')]
      const history = []
      let h
      let point
      for (let i = 0; i < this.points.length; i++) {
        point = this.points[i]
        if (this.exportType) {
          if (this.points[i].checked) {
            headerList.push(point[this.lang] + '(' + point.unit + ')')
          }
        } else {
          headerList.push(point[this.lang] + '(' + point.unit + ')')
        }
      }
      headerList.push(this.$t('device.acquisitionDate'))
      const excelList = [headerList]
      if (this.originHistoryData?.length) {
        history[0] = this.originHistoryData[0]
        let start = (this.originHistoryData[0].time + dataUnitsGap), end = (this.originHistoryData[this.originHistoryData.length - 1].time + dataUnitsGap), left = 0
        for (let i = start; i < end; i += dataUnitsGap) {
          for (let j = left; j < this.originHistoryData.length; j++) {
            h = this.originHistoryData[j]
            if (h.time > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              h = this.originHistoryData[left]
              history.push(h);
              break
            }
            if (h.time === i) {
              left = j
              history.push(h);
              break
            }
          }
        }
      }
      let data
      for (let k in history) {
        data = []
        data.push(this.deviceCode)
        data.push(this.$route.query.name)
        for (let j = 0; j < this.points.length; j++) {
          if (this.exportType) {
            if (this.points[j].checked) {
              data.push(+history[k][this.points[j].code])
            }
          } else {
            data.push(+history[k][this.points[j].code])
          }
        }
        data.push(formatDate(history[k].time, 1))
        excelList.push(data)
      }
      const wb = XLSX.utils.book_new()
      // 创建一个工作表
      const ws = XLSX.utils.aoa_to_sheet(excelList)

      // 遍历工作表中的所有单元格
      for (const cellAddress in ws) {
          if (cellAddress[0] === '!') continue // 忽略特殊单元格
          const cell = ws[cellAddress]

          // 检查单元格的值是否是可以转换为数字的字符串
          if (cell.v && /^[^a-zA-Z]*$/.test(cell.v) && !isNaN(cell.v)) {
              cell.t = 'n' // 将单元格类型设置为数字
              cell.v = parseFloat(cell.v);// 确保单元格的值为数字
          }
      }

      // 将工作表添加到工作簿中
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1")

      // 导出 Excel 文件
      XLSX.writeFile(wb, this.$route.query.name + this.$t('device.history') + formatDate(this.outerDateValue[0]) + ' - ' + formatDate(this.outerDateValue[1]) + '.xlsx')
    },
    initialAvgConsumptionChart() {
      this.avgConsumptionVisible = true
      this.optionOfAvgConsumptionChart = {
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: 70,
          bottom: 50
        },
        xAxis: [],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
      this.$nextTick(() => {
        this.avgConsumptionChart = this.$echarts.init(
          document.querySelector('.avgConsumption .chart'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false
          }
        )
      })
    },
    closeAvgConsumptionMask() {
      this.avgConsumptionVisible = false
      this.avgConsumptionChart.clear()
      this.ranges = []
    },
    addRange() {
      this.ranges.push({
        id: nanoid(),
        date: '',
        startTime: '',
        endTime: '',
        deviceCode: [],
        checked: false
      })
    },
    async renderChart () {
      const series = [],
        xAxis = [],
        rangesRecord = []
      let flag = false,
        max = 0,
        unlimit = true
      for (let i = 0; i < this.ranges.length; i++) {
        if (this.ranges[i].checked) {
          const { date, startTime, endTime } = this.ranges[i]
          if (!date || !startTime || !endTime) {
            this.$message.warning(this.$t('messages.cti'))
            flag = true
            break
          }
          let start = +startTime.split(':')[0]
          let end = +endTime.split(':')[0]
          if (start[0] > end) {
            this.$message.warning(this.$t('messages.ctr'))
            flag = true
            break
          }
          let gap = end - start + 1
          max = Math.max(max, gap)
          const range = {
            ...this.ranges[i],
            date: moment(+new Date(this.ranges[i].date)).format('YYYY-MM-DD'),
            start,
            end,
            gap,
            index: i + 1,
            show: false
          }
          if (unlimit) {
            if (gap === max) {
              range.show = true
              unlimit = false
            }
          }
          rangesRecord.push(range)
        }
      }
      if (flag) {
        return
      }
      for (let i = 0; i < rangesRecord.length; i++) {
        const record = rangesRecord[i]
        const { start, end, date, index, show, deviceCode } = record
        const { data } = await getDayReport(
          date,
          this.deviceCode + ''
        )
        const xAxisData = []
        const seriesData = []
        const endsIndex = data.length - 2
        for (let j = start - 1; j < start + max - 1; j++) {
          if (end < endsIndex) {
            if (j <= end) {
              xAxisData.push(data[j].datetime)
              seriesData.push(data[j].avgConsumption)
            } else {
              let time = data[j]?.datetime || `${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`
              xAxisData.push(time)
            }
          } else {
            if (j <= endsIndex) {
              xAxisData.push(data[j].datetime)
              seriesData.push(data[j].avgConsumption)
            } else if (j < end) {
              xAxisData.push(`${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`)
              seriesData.push(undefined)
            } else {
              xAxisData.push(`${date} ${j < 9 ? '0' + (j + 1) : j + 1}:00`)
            }
          }
        }
        xAxis.push({
          show,
          type: 'category',
          position: 'bottom',
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            onZero: true
          },
          data: xAxisData
        })
        series.push({
          name: `${this.$t('device.range')}${index}`,
          type: 'line',
          smmoth: true,
          symbol: 'none',
          xAxisIndex: i,
          axisTick: {
            alignWithLabel: true
          },
          axisLine: {
            onZero: false
          },
          data: seriesData
        })
      }
      this.optionOfAvgConsumptionChart.xAxis = xAxis
      this.optionOfAvgConsumptionChart.series = series
      this.avgConsumptionChart.setOption(this.optionOfAvgConsumptionChart, { replaceMerge: ['xAxis', 'series'] })
    },
    removeRange () {
      this.ranges = this.ranges.filter(range => !range.checked)
      if (this.ranges.length === 0) {
        this.avgConsumptionChart.clear()
      }
    },
    initialDeviceTChart () {
      this.timeShow = true
      this.optionOfTimeC = {
        tooltip: {
          trigger: 'axis',
          position(pt) {
            return [pt[0], '10%']
          }
        },
        grid: {
          top: 70,
          bottom: 150,
          containLabel: true
        },
        xAxis: {
          type: 'time',
          boundaryGap: true
        },
        yAxis: {
          type: 'value'
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 20
          },
          {
            start: 0,
            end: 20
          }
        ],
        series: []
      }
      this.$nextTick(() => {
        this.time = this.$echarts.init(
          document.getElementById('time'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false
          }
        )
        // this.time.setOption(this.optionOfTimeC)
      })
    },
    closeTime () {
      this.timeShow = false
      this.timeRanges = []
      this.timeDevice = ''
      this.time.clear()
    },
    addTimeRange () {
      this.timeRanges.push({
        id: nanoid(),
        dateRange: [],
        startTime: this.nowDateStart,
        endTime: this.nowDateEnd
      })
    },
    changeTime (e, i) {
      this.timeRanges[i].startTime = +new Date(e[0].toLocaleString().split(' ')[0])
      this.timeRanges[i].endTime = +new Date(e[1].toLocaleString().split(' ')[0]) + 24 * 3600 * 1000 - 1
    },
    async timeAnalyse () {
      this.tLoading = true
      const series = []
      const xAxis = []
      if (!this.timeDevice) {
        return this.$message.warn('请选择数据点')
      }
      try {
        for (let i = 0; i < this.timeRanges.length; i++) {
          const { startTime, endTime } = this.timeRanges[i]
          let { data } = await getDeviceHistoryData({
            deviceId: this.$route.query.id,
            pointCode: this.timeDevice,
            startTime,
            endTime
          })
          data = data.map(item => [+new Date(item.time), item[this.timeDevice]])
          series.push({
            name: `${this.$t('device.range')}${i + 1}`,
            type: 'line',
            smooth: true,
            xAxisIndex: i,
            symbol: 'none',
            emphasis: {
              focus: 'series'
            },
            data
          })
          xAxis.push({
            type: 'time',
            show: false
          })
        }
        xAxis[0].show = true
        this.optionOfTimeC.series = series
        this.optionOfTimeC.xAxis = xAxis
        this.time.setOption(this.optionOfTimeC, { replaceMerge: ['series', 'xAxis'] })
      } finally {
        this.tLoading = false
      }
    },
    timeGoBack () {
      this.timeRanges.pop()
    },
    async showRemoveHistroyDataConfirm() {
      this.removeTimeRange = [
        moment(this.startDate),
        moment(this.endDate)
      ]
      this.isRemoveHistroyDataConfirm = true
    },
    async removeHistroyData() {
      const temp = {
        deviceId: this.$route.query.id,
        // startTime: this.startDate,
        // endTime: this.endDate
      }
      temp.startTime = +new Date(this.removeTimeRange[0]._d)
      temp.endTime = +new Date(this.removeTimeRange[1]._d)
      try {
        const r = await deleteDeviceHistoryData(temp)
        this.$message.success(r.message)
        this.isRemoveHistroyDataConfirm = false
        this.render()
      } catch(e) {
        this.$message.error(e.message || (this.lang === 'en' ? 'Fail to delete' : '删除失败'))
      }
    },
    handleUnitChange (value) {
      switch (value) {
        case 's':
          this.options = [1, 5, 30]
          if (this.num) {
            this.num = 30
          }
          this.perSeconds = 1
          break
        case 'm':
          this.options = [1, 5, 30]
          this.perSeconds = 60
          break
        case 'h': 
          this.options = [1, 2, 3, 24]
          if (this.num) {
            this.num = 1
          }
          this.perSeconds = 3600
          break
      }
    },
    showRateMask() {
      const r = JSON.parse(localStorage.getItem('statisticsTime'))
      if (r) {
        const t = localStorage.getItem('saveTime')
        if (t === moment(+new Date()).format('YYYY-MM-DD')) {
          this.rateDateRange = r.map(d => new Date(d))
        } else {
          localStorage.removeItem('saveTime')
          localStorage.removeItem('statisticsTime')
          this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
        }
      } else {
        this.rateDateRange = [new Date(+new Date() - 24 * 3600000), new Date()]
      }
      this.rateTarget = this.rateResult = this.rate = ''
      this.rateShow = true
      if (this.$route.query.rateInterval) {
        this.rateInterval = this.$route.query.rateInterval
      }
    },
    openRangeMask (item, index) {
      this.index = index
      this.dataPointName = item[this.lang]
      this.shrink = false
      this.$refs.range.style.scale = 'unset'
      this.rangeStartDate = this.outerDateValue[0]
      this.rangeEndDate = this.outerDateValue[1]
      this.rangeShow = true
    },
    handleMouseDown (e) {
      const { range } = this.$refs
      const x = e.pageX - range.offsetLeft
      const y = e.pageY - range.offsetTop
      document.addEventListener('mousemove', move)
      function move(e) {
        range.style.left = e.pageX - x + 'px'
        range.style.top = e.pageY - y + 'px'
      }
      function remove() {
        document.removeEventListener('mousemove', move)
      }
      document.addEventListener('mouseup', remove)
    },
    setShrink () {
      this.shrink = !this.shrink
      if (this.shrink) {
        this.$refs.range.style.scale = '.7'
      } else {
        this.$refs.range.style.scale = 'unset'
      }
    },
    closeRangeMask () {
      this.rangeShow = false
      this.rangesChart?.clear()
      this.dataRanges = []
      this.dataRangeDetail = {}
    },
    onRangeDateChange (dateArray) {
      const startDate = new Date(dateArray[0]).getTime()
      const endDate = new Date(dateArray[1]).getTime() + 24 * 60 * 60 * 1000 - 1
      const reduce = parseInt((endDate - startDate) / 1000 / 60 / 60 / 24)
      if (reduce > 31) {
        return message.warn('日期范围最多一个月')
      }
      this.rangeStartDate = startDate
      this.rangeEndDate = endDate
    },
    addDataRange () {
      this.dataRanges.push({
        id: nanoid(),
        min: '',
        max: ''
      })
    },
    async analyse () {
      this.isLoading = true
      const index = this.index
      const { rangeStartDate: startTime, rangeEndDate: endTime } = this
      let data
      try {
        const historyList = await getDeviceHistoryData({
          deviceId: this.$route.query.id,
          pointCode: this.points[index].code,
          startTime,
          endTime
        })
        data = historyList.data
        this.dataRangeDetail = {}
        this.totalDataLength = data.length
        for (let i = 0; i < this.dataRanges.length; i++) {
          const { min, max } = this.dataRanges[i]
          let key = `${min} - ${max}`
          this.dataRangeDetail[key] = 0
          for (let j = 0; j < data.length; j++) {
            const r = data[j][this.points[index].code]
            // console.log(r, +min, +max);
            if (r >= +min && r < +max) {
              this.dataRangeDetail[key]++
            }
          }
        }
        console.log(this.dataRangeDetail);
        this.$forceUpdate()
      } finally {
        this.isLoading = false
      }
    },
    goBack () {
      const r = this.dataRanges.at(-1)
      if (r.min || r.max) {
        r.min = r.max = ''
      } else {
        this.dataRanges.pop()
      }
    },
    renderRangesChart () {
      const xAxisData = [],
        seriesData = []
      for (let key in this.dataRangeDetail) {
        xAxisData.push(key)
        seriesData.push(this.dataRangeDetail[key])
      }
      if (!this.rangesChart) {
        this.rangesChart = this.$echarts.init(
          document.querySelector('#ranges'),
          null,
          {
            render: 'canvas',
            useDirtyRect: false
          }
        )
      }
      const option = {
        tooltip: {
          trigger: 'axis'
        },
        xAxis: {
          type: 'category',
          data: xAxisData
        },
        yAxis: {
          type: 'value',
          splitLine: {
            lineStyle: {
              color: '#ccc'
            }
          }
        },
        series: [
          {
            data: seriesData,
            type: 'bar',
            itemStyle: {
              color: "#37A2FF"
            },
            label: {
              show: true,
              fontSize: 16,
              position: 'top',
              color: '#fff',
              formatter: (val) => {
                return ((val.data / this.totalDataLength) * 100).toFixed(2) + '%'
              }
            }
          }
        ]
      }
      this.rangesChart.setOption(option, { replaceMerge: ['xAxis', 'series'] })
    },
    handlePointCheckedChange(e, item) {
      item.checked = e.target.checked
      this.selectedPoints = this.points.filter(p => p.checked)
      const LKEY = `${this.deviceCode}`
      const LVALUE = this.selectedPoints.map(p => p.code)
      localStorage.setItem(LKEY, JSON.stringify(LVALUE))
      this.drawSummaryChart()
    },
    closeRate() {
      this.rateShow = false
    },
    saveTime() {
      localStorage.setItem('statisticsTime', JSON.stringify(this.rateDateRange))
      localStorage.setItem('saveTime', moment(+new Date()).format('YYYY-MM-DD'))
    },
    async setRate(f) {
      let startTime, endTime
      if (!this.rateDateRange || this.rateDateRange.length < 2 || !this.rateInterval) {
        this.rateTarget = this.rateResult = '0'
        this.rate = '0%'
        this.defaultRate = '0%'
        return
      }
      if (f) {
        startTime = +this.rateDateRange[0]
        endTime = +this.rateDateRange[1]
        this.isRateLoading = true
      } else {
        const now = +new Date()
        startTime = now - 24 * 3600000
        endTime = now
      }
      try {
        const { data } = await getDeviceHistoryData({
          deviceId: this.$route.query.id,
          pointCode: this.points.map(p => p.code) + '',
          startTime,
          endTime
        })
        if (data.length < 1) {
          const target = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
          this.rateTarget = target
          this.rateResult = '0'
          this.rate = '0%'
          this.defaultRate = '0%'
          return
        }
        let result = 1
        const gap = this.rateInterval * 1000
        let start = (Math.floor(+new Date(data[0].time) / 1000) * 1000 + gap), end = (+new Date(data[data.length - 1].time) + gap), left = 0, h
        for (let i = start; i < end; i += gap) {
          for (let j = left; j < data.length; j++) {
            h = data[j]
            h.time = Math.floor(+new Date(h.time) / 1000) * 1000
            if (h.time > i) {
              if (j - left <= 1) {
                break
              }
              left = j - 1
              result++
              break
            }
            if (h.time === i) {
              left = j
              result++
              break
            }
          }
        }
        const target = Math.floor((+this.rateDateRange[1] - +this.rateDateRange[0]) / (this.rateInterval * 1000))
        if (f) {
          this.rateTarget = target
          this.rateResult = result
          this.rate = (result / target * 100).toFixed(2) + '%'
        } else [
          this.defaultRate = (result / target * 100).toFixed(2) + '%'
        ]
      } catch(e) {
        console.log(e)
      } finally {
        this.isRateLoading = false
      }
    },
    connectWebSocket() {
      if (this.websocket) {
        this.websocket.close()
      }
      const authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token'))
      this.webSocket = new WebSocket(`wss://ygk.deman.cn:9006/ws/device/${this.$route.query.id}?token=${authorization}`)
      this.webSocket.onopen = () => {
        setTimeout(() => {
          this.webSocket.send('stop')
        }, 1000)
      }
      let record, time
      this.webSocket.onmessage = ({ data }) => {
        if (data === 'monitorTime') {
          this.webSocket.send('stop')
          return
        }
        this.flag = true
        record = JSON.parse(data)
        time = +new Date(record.time || new Date())
        for (let k in record) {
          if (this.historyMap[k]) {
            this.historyMap[k].push([time, record[k]])
          }
        }
        this.drawPointsCharts()
        this.drawSummaryChart()
      }
    },
    checkWebSocketConnecting() {
      this.timer = setInterval(() => {
        console.log(this.flag);
        if (!this.flag) {
          if (this.webSocket) {
            this.webSocket.close()
            this.webSocket = null
            this.connectWebSocket()
          }
        } else {
          this.flag = false
        }
      }, 180 * 1000)
    },
    handleDataShowModalChange() {
      this.render()
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    async setLoadRateInfoAndShowLoadRateModal() {
      this.loadRateModalButtonLoading = true
      try {
        const { data } = await searchDeviceList(1, 1000, {
          query: [],
          filter: [
            {
              field: 'customerId',
              value: this.$route.query.ci
            },
            {
              field: 'type',
              value: 'DB'
            },
            {
              field: 'mode',
              value: 'and'
            }
          ],
          sort: []
        })
        this.loadRateDateRange = [
          new Date(new Date().setHours(0, 0, 0, 0)),
          new Date()
        ]
        await this.getMemo()
        if (this.memo[1][this.$route.query.id]) {
          for (let key in this.loadRateForm) {
            this.loadRateForm[key] = this.memo[1][this.$route.query.id][this.loadRateType[0]][key] || ''
          }
          if (this.loadRateType[0] === 'IndustrialFrequency') {
            this.selectedDevice = this.memo[1][this.$route.query.id].IndustrialFrequency.device || +this.$route.query.id
          }
          if (this.loadRateType[0] === 'variableFrequency') {
            this.selectedDevices = this.memo[1][this.$route.query.id].variableFrequency.devices || +this.$route.query.id
          }
        } else {
          this.selectedDevices = +this.$route.query.id
          this.selectedDevice = +this.$route.query.id
        }
        this.loadRateForm.stanbyPower = this.loadRateForm.stanbyPower || '1'
        this.deviceList = data.records
        this.loadRateShow = true
      } catch(e) {
        console.log(e)
      } finally {
        this.loadRateModalButtonLoading = false
      }
    },
    addParamter() {
      this.parameters.push({
        id: nanoid(),
        deviceId: undefined,
        points: [],
        pointCode: []
      })
    },
    closeLoadRateModalAndClearInfo() {
      this.loadRateShow = false
      this.loadRateForm.unloadingPower = ''
      this.loadRateForm.fullLoadPower = ''
      this.loadRateForm.stanbyPower = '1'
      this.selectedDevices = undefined
      this.selectedDevice = undefined
      this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = this.dataCount = this.loadCount = this.unloadCount = 0
    },
    async selectDevice(v, i) {
      this.parameters[i].deviceId = v
      const { data } = await getProtocol(this.$route.query.pc, this.$route.query.pc)
      this.parameters[i].points = data.points.filter(d => d.dataWrite !== 2)
    },
    deleteParameter(i) {
      this.parameters.splice(i, 1)
    },
    async getLoadRate() {
      if (!this.loadRateDateRange.length) {
        return this.$message.warn(this.$t('device.selectDate'))
      }
      if ((this.loadRateDateRange[1] - this.loadRateDateRange[0]) / 1000 / 60 / 60 / 24 > 31) {
        this.isGettingLoadRateButtonLoading = false
        return this.$message.warn(this.$t('messages.moreThanOneMonth'))
      }
      let flag
      this.$refs.loadRateForm.validate(valid => {
        flag = valid
      })

      if (!flag) return this.$message.warn(this.$t('device.compeleteInfo'))
      if ((this.loadRateType[0] === 'variableFrequency' && !this.selectedDevices) || (this.loadRateType[0] === 'IndustrialFrequency' && !this.selectedDevice)) return this.$message.warn(this.$t('messages.selectDevice'))

      this.isGettingLoadRateButtonLoading = true
      const promises = []
      const result = {}
      let sd = this.loadRateType[0] === 'IndustrialFrequency' ? [this.selectedDevice] : [this.selectedDevices]
      sd.forEach(p => {
        result[p] = {}
        promises.push(new Promise(async (resolve, reject) => {
          try {
            const { data } = await getDeviceHistoryData({
              deviceId: p,
              pointCode: 'power,total_electric',
              startTime: +this.loadRateDateRange[0],
              endTime: +this.loadRateDateRange[1]
            })
            data.forEach(d => {
              result[p][moment(+new Date(d.time)).format('YYYY-MM-DD HH:mm:ss')] = d
            })
            resolve()
          } catch(e) {
            console.log(p, e)
            reject()
          }
        }))
      })

      try {
        await Promise.all(promises)
        let basicDeviceId = this.$route.query.id
        basicDeviceId = result[basicDeviceId] ? basicDeviceId : (sd[0] || 0)
  
        let exited, power = 0, total_electric = 0
        const data = []
        for (let time in (result[basicDeviceId] || {})) {
          exited = true
          power = 0
          total_electric = 0
          for (let key in result) {
            if (result[key][time]) {
              power += result[key][time].power
              total_electric += result[key][time].total_electric
            } else {
              exited = false
            }
          }
          if (exited) {
            data.push({
              time,
              power,
              total_electric
            })
          }
        }

        let count = data.length, avgPower = 0, summaryPower = 0, minPower = Infinity, maxPower = -Infinity, loadRateCount = 0, electricityMeterAccumulation = 0, eStart = 0, eEnd = count - 1, item, realCount = 0

        for (let i = 0; i < count; i++) {
          item = data[i]
          if (item.power > +this.loadRateForm.stanbyPower) {
            realCount++
            summaryPower += item.power
            if (item.total_electric) {
              eStart = Math.min(eStart, i)
              eEnd = Math.max(eEnd, i)
            }
            minPower = Math.min(minPower, item.power)
            maxPower = Math.max(maxPower, item.power)
            if (item.power > +this.loadRateForm.unloadingPower) {
              loadRateCount++
            }
          }
        }

        this.dataCount = realCount
        this.loadCount = loadRateCount
        this.unloadCount = realCount - loadRateCount
        avgPower = (summaryPower / realCount).toFixed(1)
        if (!realCount) {
          electricityMeterAccumulation = 0
          this.avgPower = 0
          this.maxPower = 0
          this.minPower = 0
          this.loadingRate = 0
          this.capacityRate = 0
          this.unloadRate = 0
          return this.$message.error(this.$t('common.nd'))
        }
        electricityMeterAccumulation = (data[eEnd].total_electric - data[eStart].total_electric).toFixed(1)
        this.avgPower = avgPower
        this.electricityMeterAccumulation = electricityMeterAccumulation
        this.maxPower = maxPower.toFixed(1)
        this.minPower = minPower.toFixed(1)
        this.loadingRate = (loadRateCount / realCount * 100).toFixed(1)
        this.unloadRate = (100 - this.loadingRate).toFixed(1)
        this.capacityRate = (avgPower / this.loadRateForm.fullLoadPower * 100).toFixed(1)
      } catch(e) {
        console.log(e)
        this.avgPower = this.electricityMeterAccumulation = this.maxPower = this.minPower = this.loadingRate = this.capacityRate = 0
      } finally {
        this.isGettingLoadRateButtonLoading = false
      }
    },
    validateDate(a) {
      if ((a[1] - a[0]) / 1000 / 60 / 60 / 24 > 31) {
        this.isGettingLoadRateButtonLoading = false
        return this.$message.warn(this.$t('messages.moreThanOneMonth'))
      }
    },
    async saveDevices() {
      if (this.memo[1][this.$route.query.id]) {
        this.isDeviceSaving = true
        if (this.loadRateType[0] === 'IndustrialFrequency') {
          this.memo[1][this.$route.query.id].IndustrialFrequency.device = this.selectedDevice
        }
        if (this.loadRateType[0] === 'variableFrequency') {
          this.memo[1][this.$route.query.id].variableFrequency.devices = this.selectedDevices
        }

        try {
          const { message } = await u(this.memo)
          this.$message.success(message)
        } catch(e) {
          console.log(e)
        } finally {
          this.isDeviceSaving = false
        }
      }
    },
    addParameter() {
      this.parametersAxisSettings.push({
        id: nanoid(),
        selectedPoints: [],
        min: "",
        max: ""
      })
    },
    deleteParameterSetting(i) {
      this.parametersAxisSettings.splice(i, 1)
    },
    confirmAxisSetting() {
      const map = {}

      let p, s
      for (let i = 0; i < this.parametersAxisSettings.length; i++) {
        p = this.parametersAxisSettings[i]

        if (p.selectedPoints && p.selectedPoints.length) {
          for (let j = 0; j < p.selectedPoints.length; j++) {
            s = p.selectedPoints[j]

            map[s] = {}

            if (!isNaN(+p.min)) {
              map[s].min = +p.min
            }

            if (!isNaN(+p.max)) {
              map[s].max = +p.max
            }
          }
        }
      }

      this.axisMap = map
      this.closeParameterSetting()
      this.drawSummaryChart()
    },
    closeParameterSetting() {
      this.isParameterSettingVisible = false
    }
  }
}
</script>

<style lang="less" scoped>
ul, li {
  margin: 0;
  padding: 0;
}
.ant-layout {
  background-color: #2f3d4f !important;
  height: auto;
}
.ant-layout::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.ant-layout::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}
.ant-layout-has-sider {
  margin: 20px;
}
.ant-layout-content {
  min-height: 860px;
}
label {
  height: 40px;
  line-height: 40px;
  font-size: 16px;
  margin-left: 10px;
  color: #fff;
}
/deep/ .ant-calendar-picker-input.ant-input {
  background-color: #2f3d4f;
}
/deep/ .el-input__inner {
  height: 40px;
  background-color: unset;
  color: #fff;
}
/deep/ .el-date-editor .el-range-separator {
  line-height: 30px;
}
/deep/ .el-date-editor .el-range__icon {
  position: absolute;
  top: 1px;
}
/deep/ .ant-form-inline .ant-form-item-with-help {
  margin-bottom: 0;
}
.img {
  float: left;
  width: 100px;
  height: 80px;
  img {
    width: 100%;
    height: 100%;
  }
}
.input {
  margin-left: 125px;
  margin-bottom: 10px;
}
.header {
  position: relative;
  overflow: hidden;
  button:not(.ant-switch) {
    background-color: #00adff;
    border-radius: 10px;
    border: none;
    height: 40px;
    width: auto;
    padding: 0 10px;
    margin-left: 15px;
    line-height: 40px;
    text-align: center;
    color: #edfaff;
    cursor: pointer;
  }
  .exportData {
    margin-left: 115px;
  }
  .pointsList {
    width: calc(100% - 25px);
    float: left;
    margin-top: 20px;
    margin-left: 25px;
    padding: 0;
    li {
      width: unset;
      list-style: none;
      float: left;
      padding: 0 10px 0 3px;
      border: 1px solid #1890ff;
      color: #118bcd;
      display: flex;
      &:hover {
        background-color: #00adff;
        color: #edfaff;
      }
      label {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        white-space: nowrap;
        cursor: pointer;
      }
      input[type^="checkbox"] {
        width: 18px;
        height: 18px;
        border: none;
        outline: none;
        vertical-align: bottom;
      }
    }
  }
}
.container {
  width: 100%;
}
.container::-webkit-scrollbar {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-track {
  width: 6px;
  background-color: #ccc;
  border-radius: 3px;
}
.container::-webkit-scrollbar-thumb {
  width: 6px;
  background-color: #4961a3;
  border-radius: 3px;
}
.charts {
  padding: 20px;
  li {
    position: relative;
    list-style: none;
    width: 100%;
    height: 300px;
    padding: 20px;
    border: 1px solid #ccc;
    h3 {
      color: #a5abb3;
    }
    div {
      position: absolute;
      top: 40px;
      left: 45px;
      padding: 0;
      z-index: 1;
    }
  }
}
.ant-spin-spinning {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  .container {
    width: 1600px;
    min-height: 600px;
    height: auto;
    max-height: 960px;
    overflow: auto;
    background-color: #2f3d4f;
    position: relative;
    padding: 40px;
    i {
      font-size: 30px;
      position: absolute;
      top: 10px;
      right: 10px;
      color: #fff;
      cursor: pointer;
    }
  }
  .box {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }
  .avgConsumption .container,
  .range .container {
    height: 800px;
  }
  .chart {
    width: 100%;
    height: 620px;
    border: 1px solid #ccc;
  }
}
/deep/ .ant-form-item-control .ant-calendar-picker-input {
  background-color: unset;
}
.statistics {
  /deep/ .el-input__icon {
    line-height: 50px;
  }
}
.statistics ul li {
  width: 100%;
  margin-bottom: 10px;
  display: flex;
}
.time li {
  width: 30%;
  float: left;
  margin-bottom: 10px;
}
.rate {
  height: 300;
  .container {
    width: 670px;
    min-height: unset;
  }
  /deep/ .el-icon-time {
    top: 2px;
    left: 3px;
  }
}
.range .chart {
  width: 75%;
  border: none;
  border-left: 1px solid #ccc;
}
.range .container {
  height: 800px;
}
.range {
  width: 1600px;
  height: 500px;
  background-color: unset;
  z-index: 1;
}
.range .wrapper {
  width: 100%;
  height: 100%;
}
.range ul {
  width: 100%;
}
.range .formList {
  width: 20%;
  padding-right: 20px;
  margin-bottom: 10px;
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.range .content {
  width: 100%;
  height: 500px;
  border: 1px solid #ccc;
  display: flex;
  justify-content: space-between;
}
.range .wrapper {
  cursor: move;
}
.range .container {
  z-index: 100;
  border: 1px solid #ccc;
}
.range .head,
.range .box {
  cursor: default;
}
.range .detail,
.range .chart {
  height: 100%;
}
.range .detail {
  width: 24%;
  padding: 20px;
  text-align: center;
}
.range .detail h3 {
  color: #fff;
  font-size: 18px;
}
.range .detail ul {
  padding: 10px 30px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  overflow: auto;
  max-height: calc(100% - 65px);
}
.range .detail ul::-webkit-scrollbar {
  width: 8px;
  border-radius: 4px;
}
.range .detail ul::-webkit-scrollbar-track {
  width: 8px;
  border-radius: 4px;
}
.range .detail ul::-webkit-scrollbar-thumb {
  width: 8px;
  background-color: #4961a3;
  border-radius: 4px;
}
.range .detail ul li {
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  display: flex;
  justify-content: space-between;
}
.range .chart {
  width: 75%;
  border: none;
  border-left: 1px solid #ccc;
}
/deep/ canvas {
  z-index: 1;
}
#summary {
  overflow: hidden;
}
.loadRate {
  .container {
    width: 1500px;
    height: 700px;
  }
  /deep/ .ant-form label {
    font-size: 16px;
    color: #fff;
  }
  /deep/ .ant-calendar-range-picker-separator {
    color: #fff;
  }
  /deep/ .ant-calendar-range-picker-input {
    color: #fff;
  }
  /deep/ .anticon-close-circle {
    background-color: #2f3d4f;
    color: #ccc;
  }
  /deep/ .ant-menu-horizontal {
    border-bottom: none;
  }
  .container {
    display: flex;
    flex-direction: column;
  }
  .box {
    display: flex;
    justify-content: space-between;
    flex: 1;
    .flex {
      width: 97%;
      display: flex;
      align-items: center;
      // justify-content: space-between;
    }
    /deep/ .el-range-input {
      margin-left: 20px;
    }
    .right {
      width: 30%;
      border: 1px solid #ccc;
      padding: 20px;
      padding-top: 10px;
      font-size: 16px;
      color: #fff;
      height: 500px;
    }
    .left {
      width: 68%;
      height: 500px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      > div {
        border: 1px solid #ccc;
        padding: 0 20px 10px;
      }
      .form {
        height: 60%;
      }
      .result {
        height: 36%;
        .data {
          color: #fff;
          font-size: 16px;
        }
        .content {
          div {
            float: left;
            width: 33%;
          }
        }
      }
      .paramGroups {
        height: 46%;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 15px;
        margin-top: 8px;
        /deep/ .ant-radio-wrapper {
          margin-left: 0 !important;
        }
        .paramGroup {
          width: 30%;
          float: left;
          display: flex;
          margin-right: 14px;
          align-items: center;
          // justify-content: space-between;
          color: #fff;
          label {
            margin-left: 10px;
          }
          /deep/ .ant-select-selection--multiple {
            height: 32px;
          }
          /deep/ .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
            height: 24px !important;
            line-height: 24px !important;
          }
        }
        /deep/ .ant-checkbox-wrapper {
          margin-bottom: 0 !important;
        }
        &::-webkit-scrollbar {
          width: 8px;
          // background-color: #ccc;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-track {
          width: 8px;
          // background-color: #ccc;
          border-radius: 4px;
        }
        &::-webkit-scrollbar-thumb {
          width: 8px;
          background-color: #4961A3;
          border-radius: 4px;
        }
        /deep/ .ant-select-focused {
          color: #fff;
        }
      }
    }
  }
}

.axis {
  .wrapper {
    width: 900px;
    height: 500px;
    position: relative;

    .container {
      width: 100%;
      height: 100%;
      min-height: unset;
      max-height: unset;
      padding: 40px 30px;

      .content {
        width: 100%;
        height: 100%;
        
        .parameters {
          width: 100%;
          height: calc(100% - 72px);
          overflow: auto;

          &::-webkit-scrollbar {
            width: 8px;
            // background-color: #ccc;
            border-radius: 4px;
          }
          &::-webkit-scrollbar-track {
            width: 8px;
            // background-color: #ccc;
            border-radius: 4px;
          }
          &::-webkit-scrollbar-thumb {
            width: 8px;
            background-color: #4961A3;
            border-radius: 4px;
          }

          li {
            position: relative;

            i {
              top: 50%;
              right: 0;
              transform: translateY(-50%);
              width: 24px;
              height: 30px;
              font-size: 24px;
            }
          }
        }
      }
    }

    footer {
      width: 100%;
      height: 60px;
      position: absolute;
      bottom: 0;

      .buttons {
        position: absolute;
        top: 50%;
        right: 18px;
        transform: translateY(-50%);
      }
    }
  }
}

/deep/ .ant-input {
  background-color: #2f3d4f;
  color: #fff;
}

/deep/ .ant-select-selection--multiple {
  height: auto;
  color: #fff;
}

.statistic .mask /deep/ .ant-select-selection--multiple > ul > li, .statistic /deep/ .ant-select-selection--multiple .ant-select-selection__rendered > ul > li {
  height: 24px !important;
  line-height: 24px !important;
}

.removeModal /deep/ .ant-calendar-range-picker-input {
  color: #333;
}
</style>
